<template>
<v-autocomplete v-model="model" :items="items" :loading="loading" :search-input.sync="search" :label="label" :placeholder="placeholder" :hint="hint" :hide-details="hideDetails" item-value="id" item-text="name" :menu-props="{transition:'scale-transition'}"
    persistent-hint clearable flat solo return-object no-filter>

    <template v-slot:selection="data">
        <v-layout row style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis; max-width:180px" fill-height align-center>
            <v-avatar v-if="data.item.avatar" size="21">
                <img :src="data.item.avatar">
            </v-avatar>
            <span :class="{'pl-2':data.item.avatar}">{{data.item.name}}</span>
        </v-layout>
    </template>
    <template v-slot:item="data">
        <v-card tile flat style="background: transparent;">
            <v-layout row fill-height align-center>
                <div class="px-1 detail">{{data.item.id}}</div>
                <div class="regular">{{data.item.name}}</div>
            </v-layout>
        </v-card>
    </template>
</v-autocomplete>
</template>

<script>
export default {
    name: `organization-search`,

    props: {
        organization: Object,
        organization_id: [String, Number],
        label: String,
        placeholder: String,
        hint: String,
        hideDetails: Boolean
    },

    data() {
        return {
            model: {
                id: null,
                name: null,
                type: null
            },
            items: [],
            loading: false,
            search: null
        }
    },

    watch: {

        search(val) {
            if(this.model && val === this.model.name) {
                return;
            }
            clearTimeout(this.search_timeout);
            this.search_timeout = setTimeout(this.getItems(val), 300);
        },

        model() {
            this.$emit('input', this.model);
        },

        organization(val) {
            this.model = {
                id: val.id,
                name: val.name,
                type: val.type,
            };
            if(val.id && val.name && val.type) {
                this.items = [this.model]
            } else {
                this.items = [];
            }
        },
        organization_id(val) {
            if(!val) {
                return
            } else {
                this.getItem()
            }
            // this.model.id = val;
            // if(val) {
            //     this.items = [this.model]
            // } else {
            //     this.items = [];
            // }
        },
    },

    methods: {

        getItems(val) {
            // quit early if no search value
            if(!val) {
                return
            }

            // loading
            this.loading = true;

            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/profiles/organizations';

            // prepare params
            let options = {
                params: {
                    search: val,
                    fields: ['name'],
                    size: 5
                }
            };

            // make places search request
            this.$axios.get(endpoint, options)
                .then(response => {
                    this.items = response.data.data;
                })
                .catch(error => {
                    console.log(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        getItem() {
            if(!this.organization_id) {
                return
            }
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/profiles/organizations/';

            this.$axios.get(endpoint + this.organization_id)
                .then(response => {
                    this.model = response.data;
                    this.items = [response.data];

                })
                .catch(error => {
                    this.error('Oops, something went wrong!');
                    console.log(error);
                })
        },

        clear() {
            this.model = {};
            this.items = [];
        }

    }

}
</script>
